import * as React from 'react';
export const metabankSvg = React.forwardRef(function metabankSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement(
      'g',
      {
        fill: 'none',
        fillRule: 'evenodd',
      },
      /*#__PURE__*/ React.createElement('path', {
        fill: '#004990',
        d: 'M0 0h32v32H0z',
      }),
      /*#__PURE__*/ React.createElement('path', {
        fill: '#FFF',
        d: 'M23.53 6.05s1.97 4.06-.65 9.46c-1.97-2.7-4.59-4.05-8.52-5.4 3.28-4.06 9.17-4.06 9.17-4.06zM5.66 15.01s4.14-4.74 8.76-5.03a10.13 10.13 0 0 0-1.09 10.14C8.4 20.15 5.66 15 5.66 15zm16.08 11.56s-6.76-2.43-8.58-6.39c5.13 1.36 7.7-.46 9.4-4.45 2.44 6.57-.82 10.84-.82 10.84z',
      }),
    ),
  );
});
metabankSvg.defaultProps = {
  xmlns: 'http://www.w3.org/2000/svg',
  viewBox: '0 0 32 32',
};
export var metabank = {
  category: 'brand',
  colorable: false,
  name: 'metabank',
  svg: metabankSvg,
};
